import { SwimlaneItem } from '@rikstv/play-common/src/forces/assetDetails/assetDetails.types';
import { isOneOf } from '@rikstv/play-common/src/utils/types/typeUtils';

import { Swimlane } from '../../pages/types';

export function getSwimlaneItemTypes(
  swimlaneItems: SwimlaneItem[],
  swimlaneStyle: Swimlane['style'],
  swimlaneType: Swimlane['type']
) {
  const isMenuItems = isOneOf(swimlaneStyle, ['MenuText', 'MenuThumbnail', 'MenuCircle', 'MenuLogo']) && swimlaneItems;
  const isSwimmingPool =
    (swimlaneStyle === 'SwimmingPool' && swimlaneItems) || (swimlaneStyle === 'SwimmingPoolPortrait' && swimlaneItems);
  const isFeaturedItems = swimlaneStyle === 'Featured' && swimlaneItems;
  const isHeroItems = swimlaneStyle === 'Hero' && swimlaneItems;
  const isPortraitItems =
    swimlaneStyle === 'StandardPortrait' ||
    swimlaneStyle === 'SwimmingPoolPortrait' ||
    swimlaneStyle === 'HeroPortrait' ||
    swimlaneStyle === 'NumberedPortrait';
  const isNumberedItems =
    (swimlaneStyle === 'NumberedPortrait' || swimlaneStyle === 'StandardNumbered') && swimlaneItems;
  const isLiveChannels = swimlaneType === 'OnTvNow' && swimlaneStyle === 'Live' && swimlaneItems;
  const isStandardItems =
    !isFeaturedItems &&
    !isHeroItems &&
    !isPortraitItems &&
    !isNumberedItems &&
    !isLiveChannels &&
    swimlaneType === 'Default' &&
    !isMenuItems &&
    swimlaneItems;
  const isContinueWatchingItems = swimlaneType === 'ContinueWatching' && swimlaneItems;
  const isMyListItems = swimlaneType === 'MyList' && swimlaneItems;

  return {
    isMenuItems,
    isSwimmingPool,
    isFeaturedItems,
    isHeroItems,
    isPortraitItems,
    isNumberedItems,
    isLiveChannels,
    isStandardItems,
    isContinueWatchingItems,
    isMyListItems,
  };
}
